import VuexTypes from '@/store/types/index';

const UsersTypes = VuexTypes.users;
export default {
  [UsersTypes.USERS_LIST]: (state, { data, status }) => {
    state.usersList = { data, status };
  },
  [UsersTypes.USER_CREATE_DATA]: (state, { data, status }) => {
    state.userCreateData = { data, status };
  },
  [UsersTypes.USER_UPDATE_DATA]: (state, { data, status }) => {
    state.userUpdateData = { data, status };
  },
  [UsersTypes.USER_CREATE]: (state, { data, status }) => {
    state.userCreate = { data, status };
  },
  [UsersTypes.USER_UPDATE]: (state, { data, status }) => {
    state.userUpdate = { data, status };
  },
  [UsersTypes.USER_UPDATE_ACTIVE]: (state, { data, status }) => {
    state.userUpdateActive = { data, status };
  },
};
